<template>
    <div class="upload-file__box" @click="handleUploadFile">
        <slot></slot>
        <el-upload
			v-show="false"
			:ref="ref"
			:action="uploadUrl"
			:data="uploadData"
			:multiple="multiple"
			:show-file-list="showFileList"
			:file-list="fileList"
			:headers="headers"
			:allowUploadType="allowUploadType"
			:on-progress="handleOnProgress"
			:on-error="handleOnError"
			:on-remove="handleOnRemove"
			:on-success="handleAfterUploadSuccess"
            :before-upload="handleBeforeUpload">
            <base-button><i class="fas fa-file"></i>
				{{btnText}}</base-button>
		</el-upload>
    </div>
</template>

<script>
	import * as conf from 'src/store/conf';
    import PortletAction from 'src/components/portlet/PortletAction.vue';
	import {getCookie} from "@/store/utils";
    import axios from 'axios'
    export default {
        name: 'upload-file',
        props: {
			value: {
				type: String,
				default: ''
			},
            uploadUrl: {
                tpye: String,
                default: conf.COMMON_PIC_UPLOAD_OSS
            },
            showFileList: {
                type: Boolean,
                default: false
            },
            autoUpload: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            uploadData: {
                type: Object,
                default: () => ({})
            },
            success: {
                type: [Function, undefined],
                default: undefined
            },
            btnText: {
                type: String,
                default: '导入计划价'
            },
            allowUploadType: {
                    type: Array,
                    default: ()=>[]
                },
            headers: {
                type: Object,
                default: () => ({
                    'AdminUserKey-Info': getCookie('AdminUserKey'),
                    'AdminUserToken-Info': getCookie('AdminUserToken'),
                    'Application-type': 'LC'
                })
            }
		},
        components: {
            'portlet-action': PortletAction
        },
        computed: {
			setValue: {
				get() {
					return this.value
				},
				set(val) {
					this.$emit('input', val)
				}
			}
        },
        methods: {
            handleBeforeUpload(file) {
                if(this.autoUpload) {
                    return true
                } else { // 自定义上传 修改文件名
                    const timeStamp = Date.now()
                    let fileName = file.name || ''
                    const copyFile = new File([file], `${timeStamp}_${fileName}`)
                    this.uploadFile(copyFile)
                    return false
                }
            },
            uploadFile(file) {
                const formdata = new FormData()
                formdata.append('file', file)
                for (const key in this.uploadData) {
                    if (Object.hasOwnProperty.call(this.uploadData, key)) {
                        formdata.append(key, this.uploadData[key])
                    }
                }
                axios.post(this.uploadUrl, formdata).then(res => {
                    this.handleAfterUploadSuccess(res.data)
                }).catch((err) => {
                    this.$message.error(err.message || '文件上传失败')
                    this.handleOnError(err)
                })
            },
            handleUploadFile() {
                console.log(this.$refs[this.ref])
                this
                    .$refs[this.ref]
                    .$refs['upload-inner']
                    .$refs.input.click();
            },
            handleAfterUploadSuccess(response) {
                // 如果有定义success 执行success 不执行下面内容
                if (this.success) return this.success(response);

                if(response.code == 0){
                    console.log(response);
                    try{
                        this.$emit('input', response.data.picFullPath || response.data.picPath)
                        this.$emit('handleSuccess', response);
                    } catch(err) {
                        console.log(err)
                    }
                    this.$message.success(response.message || '导入成功')
                }else{
                    this.$message.error(response.message || '导入失败')
                }
                // 如果定义了always事件 则之后执行
                this.$emit('always', response);
            },
            handleOnProgress(file) {
                this.$emit('handleProgress', file);
            },
            handleOnError(file) {
                this.$emit('handleError', file);
            },
            handleOnRemove(file) {
                this.$emit('handleOnRemove', file);
            }
        },
        mounted() {

        },
        data() {
            return {
							fileList:[],
                ref: 'upload-file' + new Date().getTime() + ''  + parseInt(Math.random() * 10000),
                el: null,
								file: {}
            }
        }
    }
</script>

<style scoped>
    .upload-file__box{
        display: inline-block;
    }
</style>
